export default {
    user: {
        updateUsersCoordinates: { method: 'put', url: 'address/convert/{servicePartnerId}' },
        getUsersCoordinates: { method: 'get', url: 'users/sp' },
        getUsersProjectCoordinates: { method: 'post', url: 'tickets/map' },
        onboardUser: { method: 'post', url: 'onboarding/{role}' },
        getUsersRatecard: { method: 'get', url: 'users/ratecard' },
        updateUserTerritories: { method: 'put', url: 'users/territory' },
        removeUserTerritory: { method: 'post', url: 'users/territory/remove' },
        changeWorkingStatus: { method: 'post', url: 'users/workingStatus' },
        bulkUserInvite: { method: 'get', url: 'bulkInvites/fileUpload/{roleId}' },
        getTechSupportUsers: { method: 'get', url: 'users/techSupport' },
        updateTechSupportStatusOfUser: { method: 'put', url: 'users/techSupport' },
    },
    admin: {
        createDomain: { method: 'post', url: 'admin/domain' },
        checkDomainAvailability: { method: 'post', url: 'admin/domain/availability' },
        addcourse: { method: 'post', url: 'lms/courses' },
        listcourse: { method: 'get', url: 'lms/courses' },
        getCourseById: { method: 'get', url: 'lms/courses/{courseId}' },
        publishCourse: { method: 'post', url: 'lms/courses/{courseId}/publish' },
        getCourse: { method: 'get', url: 'lms/courses/{courseId}' },
        deleteCourse: { method: 'delete', url: 'lms/courses/{courseId}' },
        uploadthumbnail: { method: 'post', url: 'lms/courses/{_id}/thumbnail' },
        updateCourse: { method: 'put', url: 'lms/courses/{courseId}' },
        updateCovidZone: { method: 'put', url: 'pincode/covid' },
        addpolls: { method: 'post', url: 'polls' },
        listpolls: { method: 'get', url: 'polls/me' },
        deletePolls: { method: 'delete', url: 'polls/{pollsId}' },
        publishPolls: { method: 'post', url: 'polls/{pollsId}/publish' },
        updatepoll: { method: 'put', url: 'polls/{pollsId}' },
        usersNotification: { method: 'post', url: 'users/notify' },
        usersNotificationImage: { method: 'post', url: 'users/notify/image' },
        resultUserList: { method: 'get', url: 'polls/{pollId}/votes' },
        pollResultCsv: { method: 'get', url: 'polls/{pollId}/votes/csv' },
        listsNotification: { method: 'get', url: 'users/notify' },
        sendSmsNotification: { method: 'post', url: 'sms' }
    },
    locations: {
        states: {
            listAllState: { method: 'get', url: 'states' },
            addState: { method: 'post', url: 'states' },
            updateState: { method: 'put', url: 'states/{stateId}' },
            deleteState: { method: 'delete', url: 'states/{stateId}' }
        },
        cities: {
            listAllCity: { method: 'get', url: 'states/0/city' },
            listStateWiseCity: { method: 'get', url: 'states/{stateId}/city' },
            updateCity: { method: 'put', url: 'states/{stateId}/city/{cityId}' },
            addCity: { method: 'post', url: 'states/{stateId}/city' },
            deleteCity: { method: 'delete', url: 'states/{stateId}/city/{cityId}' },
            listCitiesById: { method: 'get', url: 'states/0/city/{cityIds}' }
        },
        pincodes: {
            listAll: { method: 'get', url: 'pincode' },
            getCityPincodes: { method: 'get', url: 'pincode/city/{cityId}' },
            addPincode: { method: 'post', url: 'pincode' },
            updatePincode: { method: 'put', url: 'pincode/{pincodeId}' },
            deletePincode: { method: 'delete', url: 'pincode/{pincodeId}' }
        },
    },
    workflow: {
        templatesList: { method: 'get', url: 'templates' },
        addTemplate: { method: 'post', url: 'templates' },
        getTemplate: { method: 'get', url: 'templates/{templateId}' },
        cloneTemplate: { method: 'post', url: 'templates/{templateId}/clone' },
        updateTemplate: { method: 'put', url: 'templates/{templateId}' },
        deleteTemplate: { method: 'delete', url: 'templates/{templateId}' },
        fieldMastersList: { method: 'get', url: 'fieldmasters' },
        getWorkflowDetails: { method: 'get', url: 'workflow/{templateId}' },
        build: { method: 'post', url: 'workflow/{templateId}' },
        signOffTemplates: { method: 'get', url: 'templates/signoff' },
    },
    operation: {
        getAssetsMaster: { method: 'get', url: 'assetsTypes' },
        getCourierVendor: { method: 'get', url: 'courierVendor' },
        getEndUser: { method: 'get', url: 'endUser' },
        getEvent: { method: 'get', url: 'events' },
        getExecutionRemarks: { method: 'get', url: 'executionRemarks' },
        getFields: { method: 'get', url: 'field' },
        getconfigsManagement: { method: 'get', url: 'configs' },
        getBankList: { method: 'get', url: 'bank' },
        getAllowanceRemarkList: { method: 'get', url: 'remarks' },
        getRoleList: { method: 'get', url: 'roles' },
        getUseCaseList: { method: 'get', url: 'usecase' },
        getUseCaseServiceList: { method: 'get', url: 'services' },
        addAssetsMaster: { method: 'post', url: 'assetsTypes' },
        addCourierVendor: { method: 'post', url: 'courierVendor' },
        addEndUser: { method: 'post', url: 'endUser' },
        adprodent: { method: 'post', url: 'events' },
        addExecutionRemarks: { method: 'post', url: 'executionRemarks' },
        addFields: { method: 'post', url: 'field' },
        addconfigsManagement: { method: 'post', url: 'configs' },
        addBankList: { method: 'post', url: 'bank' },
        addAllowanceRemarkList: { method: 'post', url: 'remarks' },
        addRole: { method: 'post', url: 'roles' },
        addUseCase: { method: 'post', url: 'usecase' },
        addUseCaseServiceList: { method: 'post', url: 'services' },
        updateAssetsMaster: { method: 'put', url: 'assetsTypes/{assetsId}' },
        updateCourierVendor: { method: 'put', url: 'courierVendor/{courierVendorId}' },
        updateEndUser: { method: 'put', url: 'endUser/{endUserId}' },
        updateEvent: { method: 'put', url: 'events/{eventsId}' },
        updateExecutionRemarks: { method: 'put', url: 'executionRemarks/{executionRemarksId}' },
        updateFields: { method: 'put', url: 'field/{fieldId}' },
        updateconfigsManagement: { method: 'put', url: 'configs/{configsId}' },
        updateBankList: { method: 'put', url: 'bank/{bankId}' },
        updateAllowanceRemarkList: { method: 'put', url: 'remarks/{remarksId}' },
        updateRole: { method: 'put', url: 'roles/{roleId}' },
        updateUseCase: { method: 'put', url: 'usecase/{usecaseId}' },
        updateUseCaseServiceList: { method: 'put', url: 'services/{servicesId}' },
        deleteAssetsMaster: { method: 'delete', url: 'assetsTypes/{assetsId}' },
        deleteCourierVendor: { method: 'delete', url: 'courierVendor/{courierVendorId}' },
        deleteEndUser: { method: 'delete', url: 'endUser/{endUserId}' },
        deleteEvent: { method: 'delete', url: 'events/{eventsId}' },
        deleteExecutionRemarks: { method: 'delete', url: 'executionRemarks/{executionRemarksId}' },
        deleteFields: { method: 'delete', url: 'field/{fieldId}' },
        deleteconfigsManagement: { method: 'delete', url: 'configs/{configsId}/' },
        deleteBankList: { method: 'delete', url: 'bank/{bankId}' },
        deleteAllowanceRemarkList: { method: 'delete', url: 'remarks/{remarksId}' },
        deleteRole: { method: 'delete', url: 'roles/{roleId}' },
        deleteUseCase: { method: 'delete', url: 'usecase/{usecaseId}' },
        deleteUseCaseServiceList: { method: 'delete', url: 'services/{servicesId}' },
    },
    scm: {
        setAppointment: { method: 'post', url: 'feAppointment/sendAppointmentLink' },
        getCalendarTickets: { method: 'post', url: 'calendar/tickets' },
        getSiteType: { method: 'get', url: 'sitetypes' },
        updateSiteType: { method: 'put', url: 'users/sitetypes' },
        clusterticketComplete: { method: 'get', url: 'tickets/config' },
        listScmUser: { method: 'get', url: 'users?tab=scm&limit=8989&offset=0' },
        assignScogoUser: { method: 'post', url: 'tickets/{ticketId}/assign' }
    },
    customer: {
        findById: { method: 'get', url: 'customer/{userId}' },
        findAllClients: { method: 'get', url: 'customer/clients' }
    },
    tickets: {
        getTickets: { method: 'get', url: 'tickets' },
        getPromisedAmount: { method: 'get', url: 'tickets/promise/amount' },
        requestAdditionalAmount: { method: 'post', url: 'tickets/additional/amount/request' },
        processAdditionalAmount: { method: 'post', url: 'tickets/additional/amount/status' },
        addNotesToTicket: { method: 'post', url: 'tickets/notes' },
        updateDocketDetais: { method: 'put', url: 'tickets/docket' },
        createIndependentTickets: { method: 'post', url: 'tickets/independent' },
        getIndependentTicketCost: { method: 'get', url: 'tickets/independent/cost' },
        getSignOffSteps: { method: 'get', url: 'tickets/signoff/steps' },
        updateSignOffSteps: { method: 'post', url: 'tickets/signoff/steps' },
        uploadSignOff: { method: 'post', url: 'tickets/signoff/upload' },
        signedUrlsForSignoffUpload: { method: 'post', url: 'tickets/signoff/upload/signedUrl' },
        broadcast: { method: 'post', url: 'tickets/broadcast/{role}' },
        updateTicketProperties: { method: 'put', url: 'tickets/properties' },
        getChildTickets: { method: 'get', url: 'tickets/{ticketId}/children' },
        trackTicket: { method: 'get', url: 'tickets/track' },
        getTicketAssignees: { method: 'get', url: 'tickets/{ticketId}/assignees' },
        deleteTickets: { method: 'delete', url: 'tickets' },
        acceptTicket: { method: 'post', url: 'tickets/accept' },
        assignSP: { method: 'post', url: 'tickets/assign' },
        getTicketsTodayStatus: { method: 'get', url: 'tickets/todaystatus' },
        addfeIntentionStatus: { method: 'post', url: 'tickets/feNotify' }
    },
    projects: {
        emailTodaysConfigCompleteTicketsCsv: { method: 'post', url: 'csv/configTickets/today' },
        emailTomorrowsPlannedTicketsCsv: { method: 'post', url: 'csv/plannedTickets/tomorrow' },
        tagPM: { method: 'post', url: 'projects/tagpm' },
        getProjectsListNames: { method: 'get', url: 'projects/names' },
        getParticipantsList: { method: 'get', url: 'ccs/users' },
        getProjectTeams: { method: 'get', url: 'projects/{projectId}/teams' },
        updateProjectTeams: { method: 'post', url: 'projects/{projectId}/teams' },
    },
    inventory: {
        createSites: { method: 'post', url: 'sites' },
        findAllSites: { method: 'get', url: 'sites' },
        findSiteById: { method: 'get', url: 'sites/{siteId}' },
        updateSite: { method: 'put', url: 'sites/{siteId}' },
        deleteSite: { method: 'delete', url: 'sites/{siteId}' },
        createAssets: { method: 'post', url: 'assets' },
        findAllAssets: { method: 'get', url: 'assets' },
        findAssetById: { method: 'get', url: 'assets/{assetId}' },
        updateAsset: { method: 'put', url: 'assets/{assetId}' },
        deleteAsset: { method: 'delete', url: 'assets/{assetId}' },
        moveAsset: { method: 'post', url: 'assets/{assetId}/move' },
        createWarehouses: { method: 'post', url: 'warehouses' },
        findAllWarehouses: { method: 'get', url: 'warehouses' },
        findWarehouseById: { method: 'get', url: 'warehouses/{warehouseId}' },
        updateWarehouse: { method: 'put', url: 'warehouses/{warehouseId}' },
        deleteWarehouse: { method: 'delete', url: 'warehouses/{warehouseId}' },
        createSpareAssets: { method: 'post', url: 'spareassets' },
        findAllSpareAssets: { method: 'get', url: 'spareassets' },
        findSpareAssetById: { method: 'get', url: 'spareassets/{assetId}' },
        updateSpareAsset: { method: 'put', url: 'spareassets/{assetId}' },
        deleteSpareAsset: { method: 'delete', url: 'spareassets/{assetId}' },
        trackRmaTicket: { method: 'get', url: 'inventory/rma/track' },
    },
    enduser: {
        getCustomerUsers: { method: 'get', url: 'customerUsers/{userId}' }
    },
    ccs: {
        getConversations: { method: 'get', url: 'ccs/conversations' },
        conversationDetails: { method: 'get', url: 'ccs/conversations/{_id}' },
        getMessages: { method: 'post', url: 'ccs/messages' },
        doMute: { method: 'post', url: 'ccs/conversations/{_id}/mute' },
        uploadFiles: { method: 'post', url: 'ccs/conversations/{_id}/files' },
        joinConversation: { method: 'post', url: 'ccs/conversations/{_id}/join' },
        leaveConversation: { method: 'post', url: 'ccs/conversations/{_id}/leave' },
        createConversationFromSql: { method: 'post', url: 'ccs/conversations/sql' },
        sysMsgs: { method: 'post', url: 'ccs/conversations/{_id}/sysMsgs' },
        createSupport: { method: 'post', url: 'ccs/support/create' },
        closeConversation: { method: 'post', url: 'ccs/conversations/{_id}/close' },
        approveRejectMedia: { method: 'post', url: 'ccs/conversations/{_id}/media/approve' },
        uploadProjectAdditionalFiles: { method: 'post', url: 'ccs/conversations/{_id}/projectfiles' },
        leaveFromMultipleConversations: { method: 'post', url: 'ccs/conversations/leave' },
        emailAllMedia: { method: 'post', url: 'ccs/medias/download' },
        saveAndBroadcastMessage: { method: 'post', url: 'ccs/conversations/{_id}/broadcast' },
        getConversationCount: { method: 'get', url: 'ccs/conversations/count' },
        getconfigsDetails: { method: 'get', url: 'tickets/{ticketId}/config' },
        downloadCustomerReport: { method: 'get', url: 'tickets/signoff/pdf' },
        transformMedia: { method: 'post', url: 'ccs/medias/transform' },
    },
    wallet: {
        addAmount: { method: 'post', url: 'wallet/order' },
        getWalletDetails: { method: 'get', url: 'wallet' },
        updateWallet: { method: 'put', url: 'wallet' },
        getTransactions: { method: 'get', url: 'wallet/transactions' },
        withdraw: { method: 'post', url: 'wallet/withdraw' },
        getTransactionStatus: { method: 'get', url: 'wallet/order/status' },
        getWalletPaymentStatus: { method: 'get', url: 'wallet/payments/status' },
        rewardUser: { method: 'post', url: 'wallet/rewards' },
    },
    fe: {
        dashboardPromiseAmount: { method: 'get', url: 'tickets/promise/amount' },
    },
    utils: {
        searchModule: { method: 'get', url: 'search' },
        getFilteredList: { method: 'get', url: 'filter/list' },
        filterModule: { method: 'post', url: 'filter' },
        exportCsv: { method: 'post', url: 'csv/export' },
        uploadFiles: { method: 'post', url: 'files/upload' },
        getGeocodeDetails: { method: 'post', url: 'location/geocode' },
        sendEmail: { method: 'post', url: 'email' },
        updateGeocodeDetails: { method: 'put', url: 'location/geocode/update' },
    },
    spareinventory: {
        getSpareCategories: { method: 'get', url: 'sparecategory' }
    },
    sp: {
        sharePublicProfile: { method: 'get', url: 'users/{userId}/profile' },
        getidCard: { method: 'get', url: 'ccs/users/{userId}' }
    },
    notifications: {
        getNotification: { method: 'get', url: 'users/notifications' },
        readNotification: { method: 'post', url: 'users/notifications' }
    },
    policies: {
        createSlas: { method: 'post', url: 'policies/sla' },
        getAllSlas: { method: 'get', url: 'policies/sla' },
        getAllSlaById: { method: 'get', url: 'policies/sla/{id}' },
        updateSlaById: { method: 'put', url: 'policies/sla/{id}' },
        createNotifications: { method: 'post', url: 'policies/notifications' },
        getAllNotifications: { method: 'get', url: 'policies/notifications' },
        getNotificationById: { method: 'get', url: 'policies/notifications/{id}' },
        updateNotificationById: { method: 'put', url: 'policies/notifications/{id}' },
        createAssignments: { method: 'post', url: 'policies/assignment' },
        getAllAssignments: { method: 'get', url: 'policies/assignment' },
        getAssignmentById: { method: 'get', url: 'policies/assignment/{id}' },
        updateAssignmentById: { method: 'put', url: 'policies/assignment/{id}' }
    },
    ratecards: {
        createRatecards: { method: 'post', url: 'ratecards' },
        getRatecards: { method: 'get', url: 'ratecards' },
        updateRatecards: { method: 'put', url: 'ratecards/{ratecardId}' },
        deleteRatecards: { method: 'delete', url: 'ratecards/{ratecardId}' }
    },
    superdesk: {
        getCustomerTeams: { method: 'get', url: 'superdesk/teams' },
        getCustomerTeamById: { method: 'get', url: 'superdesk/teams/{teamId}' },
    }
}
